var map = {
	"./DataScience.png": 222,
	"./IoT.png": 223,
	"./ML.png": 224,
	"./codeyantra-website.png": 107,
	"./coding.png": 225,
	"./exp1.png": 91,
	"./exp2.png": 93,
	"./exp3.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;